import { SortingOrderType } from 'src/app/interfaces/search.interface';

export interface SortIconItemOptions {
  ascending: boolean;
  currentSortCategory: SortingOrderType;
  preparedSortCategory: SortingOrderType;
}

export function setSortOptionsForIconElement(params: SortIconItemOptions): SortIconItemOptions {
  return {
    ascending: params.ascending,
    currentSortCategory: params.currentSortCategory,
    preparedSortCategory: params.preparedSortCategory,
  };
}
